import StoreUtil from '@/store/StoreUtil'

export default {
  ERRORS: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.meta, 'errors'),
  COUNTRIES: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.meta,
    'countries'
  ),
  REGIONS: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.meta, 'regions'),
  CLIENT_COUNTRY: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.meta,
    'clientCountry'
  ),
  PRINT_MODE: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.meta,
    'printMode'
  ),
}
